import React, { FC } from "react";

const ChevronsUp: FC = () => {
    return (
        <svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M11.7127 14.0281L12.9626 12.7782C13.1578 12.5829 13.1578 12.2663 12.9626 12.0711L7.27344 6.38195C7.07818 6.18668 6.7616 6.18668 6.56634 6.38195L0.877206 12.0711C0.681944 12.2663 0.681851 12.5828 0.877113 12.7781L2.13234 14.0333C2.32457 14.2255 2.63503 14.2288 2.83144 14.0409L6.9845 10.0664L11.0082 14.0307C11.2039 14.2235 11.5184 14.2223 11.7127 14.0281ZM11.7127 8.37481L12.9626 7.1249C13.1578 6.92963 13.1578 6.61305 12.9626 6.41779L7.27344 0.728657C7.07818 0.533394 6.7616 0.533394 6.56634 0.728657L0.877206 6.41779C0.681944 6.61305 0.681851 6.92954 0.877113 7.1248L2.13234 8.38003C2.32457 8.57226 2.63503 8.57553 2.83144 8.38756L6.9845 4.41316L11.0082 8.37743C11.2039 8.57022 11.5184 8.56905 11.7127 8.37481Z"
                fill="#E30613"
            />
        </svg>
    );
};

export default React.memo(ChevronsUp);
